import { render, staticRenderFns } from "./JoinSession.vue?vue&type=template&id=e10a55a4&scoped=true"
import script from "./JoinSession.vue?vue&type=script&lang=ts"
export * from "./JoinSession.vue?vue&type=script&lang=ts"
import style0 from "./JoinSession.vue?vue&type=style&index=0&id=e10a55a4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10a55a4",
  null
  
)

export default component.exports